'use strict';

const parallax = {
	setupParallax : function(){
		if( window.innerWidth >= 992 ) {
			const parallaxItems = document.getElementsByClassName('parallax-select');
			for(const item of parallaxItems) {
				const speed = item.dataset.parallax ? item.dataset.parallax : 5;
				const direction = item.dataset.parallaxDirection ? item.dataset.parallaxDirection : 'normal';
				if( speed ){
					this.initItemParallax(item, speed, direction)
				}
			}
		}
	},

	initItemParallax : function(element, speed, direction = 'normal'){
		window.addEventListener('scroll', e => {
			const offset = element.getBoundingClientRect();
			const topElement	= offset.top + window.scrollY;
			const bottomElement	= offset.top + window.scrollY + offset.height;
			const bottomScreen	= window.scrollY + window.innerHeight;
			const topScreen		= window.scrollY;

			if((bottomScreen > topElement) && (topScreen < bottomElement) && window.innerWidth >= 992) {	
				const scrollTop = (direction == 'normal' ? topScreen : bottomScreen) - topElement;
				element.style.transform = 'translate3d(0,'+ scrollTop / speed +'px,0)';
			}
		});
	},

	init : function(){
		window.onresize = this.setupParallax;
		this.setupParallax();
	}
};


window.addEventListener('DOMContentLoaded', function() {
	parallax.init();
});